angular.module('zc.projects')

.directive 'zcCampaignSegmentOptions', (
  $translate
  Meta
  ProjectAdvertising
  ProjectNewsletterParameter
  ProjectLoginEvaluator
  PageType
) ->
  restrict: 'E'
  templateUrl: '/templates/projects.segments/campaign_segment_options.html'
  replace: true
  scope:
    project: '='
    segment: '='
    showOnly: '='
  link: (scope, element, attrs) ->
    scope.allowedConditionsByType = {}

    scope.isAllowedCondition = (condition) -> false

    scope.advertisings = []
    scope.newsletterParameters = []
    scope.loginEvaluators = []
    scope.pageTypes = []
    scope.allPageTypes = []
    scope.allCountryCodes = []

    scope.currentLimitPageTypes = []
    scope.currentExcludePageTypes = []

    scope.currentLimitToSessionsWhoVisit = []
    scope.currentExcludeSessionsWhoVisit = []

    scope.currentLimitOfferPageTypes = []
    scope.currentExcludeOfferPageTypes = []

    ProjectAdvertising.all(scope.project.id).then (res) -> scope.advertisings = res
    ProjectNewsletterParameter.all(scope.project.id).then (res) -> scope.newsletterParameters = res
    ProjectLoginEvaluator.all(scope.project.id).then (res) -> scope.loginEvaluators = res

    scope.filterPageTypes = (segment) ->
      # landing_page_types
      if segment && segment.conditions_json.limit_to_landing_page_types
        scope.currentLimitPageTypes = _.filter scope.allPageTypes, (d) ->
          # TODO: multiple page support (for now one is enough though)
          _.includes([d.page_type, d.custom_name], segment.conditions_json.limit_to_landing_page_types[0])

      if segment && segment.conditions_json.exclude_landing_page_types
        scope.currentExcludePageTypes = _.filter scope.allPageTypes, (d) ->
          # TODO: multiple page support (for now one is enough though)
          _.includes([d.page_type, d.custom_name], segment.conditions_json.exclude_landing_page_types[0])

      # sessions_who_visit
      if segment && segment.conditions_json.limit_to_sessions_who_visit
        scope.currentLimitToSessionsWhoVisit = _.filter scope.allPageTypes, (d) ->
          # TODO: multiple page support (for now one is enough though)
          _.includes([d.page_type, d.custom_name], segment.conditions_json.limit_to_sessions_who_visit[0])

      if segment && segment.conditions_json.exclude_sessions_who_visit
        scope.currentExcludeSessionsWhoVisit = _.filter scope.allPageTypes, (d) ->
          # TODO: multiple page support (for now one is enough though)
          _.includes([d.page_type, d.custom_name], segment.conditions_json.exclude_sessions_who_visit[0])

      # offer_page_types
      if segment && segment.conditions_json.limit_to_offer_page_types
        scope.currentLimitOfferPageTypes = _.filter scope.allPageTypes, (d) ->
          # TODO: multiple page support (for now one is enough though)
          _.includes([d.page_type, d.custom_name], segment.conditions_json.limit_to_offer_page_types[0])

      if segment && segment.conditions_json.exclude_offer_page_types
        scope.currentExcludeOfferPageTypes = _.filter scope.allPageTypes, (d) ->
          # TODO: multiple page support (for now one is enough though)
          _.includes([d.page_type, d.custom_name], segment.conditions_json.exclude_offer_page_types[0])

    Promise.all([
      Meta.getCampaignSegmentAllowedConditions()
      PageType.all(scope.project.id)
      Meta.getPageTypes()
      Meta.getCountryCodes()
    ])
    .then ([allowedConditionsByType, allPageTypes, pageTypes, allCountryCodes]) ->
      scope.allowedConditionsByType = allowedConditionsByType
      scope.allPageTypes = allPageTypes
      scope.allCountryCodes = allCountryCodes
      pageTypes = _.filter(pageTypes, (pageType) -> pageType.name != '_custom_')
      customPageTypes = _.chain(allPageTypes)
        .filter({ page_type: '_custom_' })
        .uniqBy('custom_name')
        .map((page_type) -> {
          label: $translate.instant('projectsSegments.directives.campaignSegmentOptions.kasutamu', { customname: page_type.custom_name }),
          name: page_type.custom_name
        })
        .value()
      scope.pageTypes = customPageTypes.concat(pageTypes)

      scope.isAllowedCondition = (condition) ->
        return false if !scope.segment
        return false if !scope.allowedConditionsByType[scope.segment.segment_type]
        scope.allowedConditionsByType[scope.segment.segment_type].indexOf(condition) >= 0

      scope.toggleTrigger = (trigger) ->
        idx = scope.segment.conditions_json.triggers.indexOf(trigger)
        if idx >= 0
          scope.segment.conditions_json.triggers.splice(idx, 1)
        else
          scope.segment.conditions_json.triggers.push(trigger)

      scope.hasDetails = () ->
        return false if !scope.segment
        for condition in scope.allowedConditionsByType[scope.segment.segment_type]
          if _.includes(_.keys(scope.segment.conditions_json), condition)
            return true
        return false

      # landing_page_types
      if scope.isAllowedCondition('limit_to_landing_page_types')
        scope.segment.conditions_json.limit_to_landing_page_types ||= []
        scope.segment.conditions_json.limit_to_landing_page_types[0] ||= 'NOT_SELECTED'

      if scope.isAllowedCondition('exclude_landing_page_types')
        scope.segment.conditions_json.exclude_landing_page_types ||= []
        scope.segment.conditions_json.exclude_landing_page_types[0] ||= 'NOT_SELECTED'

      # sessions_who_visit
      if scope.isAllowedCondition('limit_to_sessions_who_visit')
        scope.segment.conditions_json.limit_to_sessions_who_visit ||= []
        scope.segment.conditions_json.limit_to_sessions_who_visit[0] ||= 'NOT_SELECTED'

      if scope.isAllowedCondition('exclude_sessions_who_visit')
        scope.segment.conditions_json.exclude_sessions_who_visit ||= []
        scope.segment.conditions_json.exclude_sessions_who_visit[0] ||= 'NOT_SELECTED'

      # offer_page_types
      if scope.isAllowedCondition('limit_to_offer_page_types')
        scope.segment.conditions_json.limit_to_offer_page_types ||= []
        scope.segment.conditions_json.limit_to_offer_page_types[0] ||= 'NOT_SELECTED'

      if scope.isAllowedCondition('exclude_offer_page_types')
        scope.segment.conditions_json.exclude_offer_page_types ||= []
        scope.segment.conditions_json.exclude_offer_page_types[0] ||= 'NOT_SELECTED'

      if scope.isAllowedCondition('triggers')
        scope.segment.conditions_json.triggers ||= []

        # Fallback code for old segments that are copied,
        # because nowadays we handle empty `triggers` array as 'NOT_SELECTED'
        notIncludedIndex = scope.segment.conditions_json.triggers.indexOf('NOT_SELECTED')
        if notIncludedIndex != -1
          scope.segment.conditions_json.triggers.splice(notIncludedIndex, 1)

      scope.filterPageTypes(scope.segment)

    scope.$watchCollection 'segment.conditions_json.limit_to_landing_page_types', (newval) ->
      if newval
        scope.filterPageTypes(scope.segment)

    scope.$watchCollection 'segment.conditions_json.exclude_landing_page_types', (newval) ->
      if newval
        scope.filterPageTypes(scope.segment)

    scope.$watchCollection 'segment.conditions_json.limit_to_sessions_who_visit', (newval) ->
      if newval
        scope.filterPageTypes(scope.segment)

    scope.$watchCollection 'segment.conditions_json.exclude_sessions_who_visit', (newval) ->
      if newval
        scope.filterPageTypes(scope.segment)

    scope.$watchCollection 'segment.conditions_json.limit_to_offer_page_types', (newval) ->
      if newval
        scope.filterPageTypes(scope.segment)

    scope.$watchCollection 'segment.conditions_json.exclude_offer_page_types', (newval) ->
      if newval
        scope.filterPageTypes(scope.segment)



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_options.directive.coffee